import axiosInstance from "./axiosInstance";

// Get all reviewtags
export const fetchReviewTags = async () => {
    const response = await axiosInstance.get("/reviewtag/getall");
    return response.data;
};

// Create a new reviewtag
export const createReviewTag = async (data) => {
    const response = await axiosInstance.post("/reviewtag", data);
    return response.data;
};

// Update a reviewtag
export const updateReviewTag = async ({ id, data }) => { 
    const response = await axiosInstance.put(`/reviewtag/${id}`, data);
    return response.data;
};

// Delete a reviewtag
export const deleteReviewTag = async (data) => {
    await axiosInstance.delete(`/reviewtag`, {
        params: data
    });
};
